import styled from '@emotion/styled'

import { CONFIG } from '@/styles/emotion.config'

import type { PremiumArticleCard } from '../types'

import CardArticlePremium from './ArticleCard'

interface CardProps {
  cards?: PremiumArticleCard[]
}

const ListStyles = styled.ul`
  overflow-x: auto;
  display: flex;
  gap: 1rem;
  li {
    display: inline-block;
  }
  ${CONFIG.media.lg} {
    width: 976px;
  }
`

const ArticlesList = ({ cards }: CardProps) => (
  <ListStyles>
    {cards?.map((card, index) => (
      <li key={index}>
        <CardArticlePremium className="eu-sm-2" card={card} />
      </li>
    ))}
  </ListStyles>
)

export default ArticlesList
